module.exports = __webpack_public_path__ + "img/ad_pic.9ccb990d.png";